import Swal from "sweetalert2";
import { Store } from "@ngrx/store";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AppState } from "src/app/store/index.selector";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { TableService } from "src/app/shared/services/table.service";
import { BaseTableComponent, DatatableColumn } from "src/app/shared/components/base-table/base-table.component";
import { MessagePortalComponent } from "src/app/portal/portal";
import { PositioningService } from "src/app/shared/services/positioning.service";
import { toggleAnimation } from "src/app/shared/animations";
import { Testemonial } from "src/app/shared/types/testemonial";
import { TestemonialService } from "src/app/shared/services/testemonial.service";
import { Picklist } from "src/app/shared/types/blog-types";
import { Observable } from "rxjs";
import { PicklistType } from "src/app/shared/enums/picklist-types";
import { PicklistService } from "src/app/shared/services/picklist.service";

@Component({
  templateUrl: "./testemonials.table.component.html",
  standalone: false,
  animations: [toggleAnimation],
})
export class TestemonialsTableComponent extends BaseTableComponent<Testemonial> implements OnInit {
  searchText = "";
  public languageOptions$!: Observable<Picklist[]>;
  @ViewChild("dropdownPlaceholder") dropdownPlaceholder!: ElementRef;
  @ViewChild(MessagePortalComponent) messagePortalComponent!: MessagePortalComponent;

  selectedLanguage!: string;
  selectedApplication!: string;

  constructor(
    private testemonialService: TestemonialService,
    public override translate: TranslateService,
    public override store: Store<AppState>,
    public override tableService: TableService,
    private positioningService: PositioningService,
    private picklistService: PicklistService,
  ) {
    super(store, tableService, `Testemonials/paginated`, translate);
  }

  @ViewChild("datatable") datatable: any;

  override ngOnInit(): void {
    this.languageOptions$ = this.picklistService.getPicklistOptions(PicklistType.Language);
    super.ngOnInit();
  }

  getColumns(): void {
    this.cols = [
      { field: "id", title: "Id", hide: true } as DatatableColumn,
      { field: "title", title: this.translate.instant("blogs.title") } as DatatableColumn,
      { field: "content", title: this.translate.instant("blogs.content"), hide: true } as DatatableColumn,
      { field: "categoryId", title: this.translate.instant("blogs.category") } as DatatableColumn,
      { field: "created", title: this.translate.instant("blogs.created") } as DatatableColumn,
      { field: "updatedAt", title: this.translate.instant("blogs.updated_at") } as DatatableColumn,
      { field: "actions", title: this.translate.instant("blogs.actions"), sort: false } as DatatableColumn,
    ];
  }

  handleDelete(id: number) {
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("testemonial.confirm_delete"),
      showCancelButton: true,
      confirmButtonText: this.translate.instant("blogs.yes"),
      cancelButtonText: this.translate.instant("blogs.no"),
      customClass: {
        confirmButton: "swal2-confirm btn btn-primary",
        cancelButton: "swal2-cancel btn btn-secondary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        const deleteSubscription = this.testemonialService.deleteTestemonial(id).subscribe({
          next: () => {
            deleteSubscription.unsubscribe();
            this.loading = false;
            showMessage(PopupType.Success, this.translate.instant("testemonial.deleted_successfully"));
            this.fetchItems(this.getPaginationParams());
          },
          error: (error) => {
            deleteSubscription.unsubscribe();
            this.loading = false;
            showMessage(PopupType.Danger, this.translate.instant("testemonial.invalid_deleted"));
            console.error("Error making DELETE request:", error);
          },
        });
      }
    });
  }

  setSearchText(text: string) {
    setTimeout(() => {
      this.search = text;
    });
  }

  onPortalAttached() {
    setTimeout(() => {
      this.positioningService.setPosition(this.dropdownPlaceholder, this.messagePortalComponent);
    }, 0);
  }

  onFilterChange() {
    this.language = this.selectedLanguage ?? "";
    this.fetchItems(this.getPaginationParams());
  }
}
